import { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./MainLayout.scss";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function MainLayout({ children }) {
  const location = useLocation();
  const { user } = useAuth();
  const isAuthed = !!user;

  // === Preload background images ===
  useEffect(() => {
    const preloadImages = [
      require("../assets/images/3dblue-16x9.png"),
      require("../assets/images/2trika.png"),
      require("../assets/images/3dwhite-16x9.png"),
      require("../assets/images/bg-3x4.png"),
    ];
    preloadImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  // === Determine current route ===
  const isMerchPage =
    isAuthed && location.pathname.startsWith("/products/merch");
  const isDetailPage = isAuthed && location.pathname.startsWith("/product/");
  const isWelcomePage =
    isAuthed &&
    (location.pathname === "/" || location.pathname === "/products");
  const isCartPage = isAuthed && location.pathname === "/cart";
  const isCheckoutPage = isAuthed && location.pathname === "/checkout";
  const isAdminPage = isAuthed && location.pathname.startsWith("/admin");

  const isLoginPage =
    !isAuthed &&
    (location.pathname === "/" ||
      location.pathname === "/login" ||
      location.pathname === "/signin");

  // === Compose background class list ===
  const contentClasses = ["layout__content"];

  if (!isAuthed) {
    if (isLoginPage) {
      contentClasses.push("layout__content--login");
    } else {
      contentClasses.push("layout__content--plain");
    }
  } else {
    if (isAdminPage) contentClasses.push("layout__content--admin");
    if (isCartPage || isCheckoutPage)
      contentClasses.push("layout__content--cartdark");
    if (isWelcomePage) contentClasses.push("layout__content--welcome");
    if (isMerchPage) contentClasses.push("layout__content--merch");
    if (isDetailPage) contentClasses.push("layout__content--detail");
  }

  return (
    <div className="layout">
      <Header />
      <main className={contentClasses.join(" ")}>
        <div className="layout__content-inner">{children}</div>
      </main>
      <Footer />
    </div>
  );
}
